<template>
  <div id="restaurant">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'restaurant'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/service/restaurant/Restaurant.vue